/* global ma */
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_API_URL } from '../constants';
import { getHeaders } from '../utlis/security';

export const audioBookDetailRelatedPageApi = createApi({
  reducerPath: 'audioBookDetailRelatedPageApi',
  baseQuery: fetchBaseQuery({ 
    baseUrl: BASE_API_URL,
    prepareHeaders: async (headers) => {
      const customHeaders = await getHeaders('audioBookDetailRelatedPageApi');
      for (const [key, value] of Object.entries(customHeaders)) {
        headers.set(key, value);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    fetchAudioBookDetailRelatedData: builder.query({
      query: (option) => ({
        url : 'detail_page_authors',
        method: 'POST',
        body : {
            "item_id": option,
            "phone": "",
            "platform": "Android",
            "udid": "190740e5f0032702",
            "user_id": "",
            "version_code": 29,
            "version_name": "1.2.9"
        },
      }), 
    })
  }),
});

export const { useFetchAudioBookDetailRelatedDataQuery, endpoints } = audioBookDetailRelatedPageApi;